/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Link_WebInputs */

const en_dialog_link_web = /** @type {(inputs: Dialog_Link_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link a web page`)
};

const es_dialog_link_web = /** @type {(inputs: Dialog_Link_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vincular una página web`)
};

/**
* | output |
* | --- |
* | "Link a web page" |
*
* @param {Dialog_Link_WebInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_link_web = /** @type {((inputs?: Dialog_Link_WebInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Link_WebInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_link_web(inputs)
	return en_dialog_link_web(inputs)
});